import withLazyLoad from '@libs/@core/hocs/withLazyLoad';
export var LoginTemplateLazy = withLazyLoad(function () { return import(/* webpackChunkName: "login" */ '@modules/auth/templates/login.template'); });
export var HomeTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "manage-line" */ '@modules/_home/templates/index.template').then(function (module) { return ({
        default: module.HomeTemplate
    }); });
});
// ========== Account Management Lazy Component ==========
export var AccountManagementTemplateLazy = withLazyLoad(function () {
    return import(
    /* webpackChunkName: "account-management" */ '@modules/account-management/templates/account-management.template');
});
// ========== Cashflow Overview Lazy Component ==========
export var CashFlowOverviewTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "cash-flow-overview" */ '@modules/cashflow/cf-overview/templates/index.template').then(function (module) { return ({
        default: module.OverviewTemplate
    }); });
});
// ========== Cashflow Statement Lazy Component ==========
export var CashFlowStatementTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "cash-flow-statement" */ '@modules/cashflow/cf-statement/templates/index').then(function (module) { return ({
        default: module.CfStatementTemplate
    }); });
});
export var EditCashflowStatementTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "edit-cash-flow-statement" */ '@modules/cashflow/cf-statement/templates/index').then(function (module) { return ({
        default: module.EditCashflowStatementTemplate
    }); });
});
export var ViewStatementTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "view-statement" */ '@modules/cashflow/cf-statement/templates/index').then(function (module) { return ({
        default: module.ViewStatementTemplate
    }); });
});
// ========== Cashflow Template Lazy Component ==========
export var CashFlowTemplateTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "cash-flow-template" */ '@modules/cashflow/cf-template/templates/index.template').then(function (module) { return ({
        default: module.CashFlowTempTemplate
    }); });
});
export var CreateCashFlowTempTemplateLazy = withLazyLoad(function () {
    return import(
    /* webpackChunkName: "create-cash-flow-template" */ '@modules/cashflow/cf-template/templates/index.template').then(function (module) { return ({
        default: module.CreateCashFlowTempTemplate
    }); });
});
// ========== Multi Languages Lazy Component ==========
export var MultiLanguagesTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "multi-languages-template" */ '@modules/multi-languages/templates/index').then(function (module) { return ({
        default: module.MultiLanguagesTemplate
    }); });
});
// ========== Department Management Lazy Component ==========
export var DeptManagementTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "dept-management" */ '@modules/dept-management/templates/index').then(function (module) { return ({
        default: module.DeptManagementTemplate
    }); });
});
// ========== AggregrateCf Lazy Component ==========
export var AggregrateCfTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "aggregrate-cf" */ '@modules/cashflow/aggregrate-cf/templates/index').then(function (module) { return ({
        default: module.AggregrateCfTemplate
    }); });
});
// ========== SupplierManagement Lazy Component ==========
export var SupplierManagementTemplateLazy = withLazyLoad(function () {
    return import(
    /* webpackChunkName: "supplier-management" */ '@modules/ap-management/supplier-management/templates/index').then(function (module) { return ({
        default: module.SupplierManagementTemplate
    }); });
});
// ========== SupplierBalance Lazy Component ==========
export var SupplierBalanceTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "supplier-balance" */ '@modules/ap-management/supplier-balance/templates/index').then(function (module) { return ({
        default: module.SupplierBalanceTemplate
    }); });
});
// ========== SupplierBalance Lazy Component ==========
export var SupplierLineItemsTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "supplier-balance" */ '@modules/ap-management/supplier-balance/templates/index').then(function (module) { return ({
        default: module.SupplierLineItemsTemplate
    }); });
});
// ========== ApOverview Lazy Component ==========
export var ApOverviewTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "ap-overview" */ '@modules/ap-management/ap-overview/templates/index').then(function (module) { return ({
        default: module.ApOverviewTemplate
    }); });
});
// ========== ArOverview Lazy Component ==========
export var ArOverviewTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "ar-overview" */ '@modules/ar-management/ar-overview/templates/index').then(function (module) { return ({
        default: module.ArOverviewTemplate
    }); });
});
// ========== CustomerManagement Lazy Component ==========
export var CustomerManagementTemplateLazy = withLazyLoad(function () {
    return import(
    /* webpackChunkName: "customer-management" */ '@modules/ar-management/customer-management/templates/index').then(function (module) { return ({
        default: module.CustomerManagementTemplate
    }); });
});
// ========== CustomerBalance Lazy Component ==========
export var CustomerBalanceTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "customer-balance" */ '@modules/ar-management/customer-balance/templates/index').then(function (module) { return ({
        default: module.CustomerBalanceTemplate
    }); });
});
// ========== CustomerBalance Lazy Component ==========
export var CustomerLineItemsTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "customer-balance" */ '@modules/ar-management/customer-balance/templates/index').then(function (module) { return ({
        default: module.CustomerLineItemsTemplateLazy
    }); });
});
// ========== Payment Lazy Component ==========
export var PaymentTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "payment" */ '@modules/automation/payment/templates/index').then(function (module) { return ({
        default: module.PaymentTemplate
    }); });
});
export var PaymentLogTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "view-payment" */ '@modules/automation/payment/templates/index').then(function (module) { return ({
        default: module.ViewPaymentTemplate
    }); });
});
export var EditPaymentTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "edit-payment" */ '@modules/automation/payment/templates/index').then(function (module) { return ({
        default: module.EditPaymentTemplate
    }); });
});
export var CreatePaymentProposalTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "create-payment" */ '@modules/automation/payment/templates/index').then(function (module) { return ({
        default: module.CreatePaymentTemplate
    }); });
});
// ========== DunningLetter Lazy Component ==========
export var DunningLetterTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "dunning-letter" */ '@modules/automation/dunning-letter/templates/index').then(function (module) { return ({
        default: module.DunningLetterTemplate
    }); });
});
export var ExecutionLogTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "view-dunning-letter" */ '@modules/automation/dunning-letter/templates/index').then(function (module) { return ({
        default: module.ViewDunningLetterTemplate
    }); });
});
export var LetterLayoutTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "edit-dunning-letter" */ '@modules/automation/dunning-letter/templates/index').then(function (module) { return ({
        default: module.LetterLayoutTemplate
    }); });
});
export var CreateDunningLetterTemplateLazy = withLazyLoad(function () {
    return import(/* webpackChunkName: "create-dunning-letter" */ '@modules/automation/dunning-letter/templates/index').then(function (module) { return ({
        default: module.CreateDunningLetterTemplate
    }); });
});
